import Repository from './Repository'

export default {
  login(formData) {
    return Repository.public().post(`/auth/request-token`, formData)
  },
  sooLogin(formData) {
    return Repository.public().post(`/auth/request-token-sso`, formData)
  },
  logout() {
    return Repository.private().post(`/user/logout/`)
  }
}
